import React, {Component} from 'react';
import {Helmet} from "react-helmet-async";
import PropTypes from "prop-types";

class MetaTags extends Component {
  static propTypes = {
    meta_tags: PropTypes.object
  };

  render() {
    const meta_tags = this.props.meta_tags || {};

    return (
      <Helmet>
        <title>{(meta_tags.title || (meta_tags.default && meta_tags.default.title) || process.env.REACT_APP_META_TITLE)}</title>
        <meta name="description" content={meta_tags.description || process.env.REACT_APP_META_DESCRIPTION} />

        {meta_tags.image_src && <link rel="image_src" href={meta_tags.image_src} />}
        {meta_tags.image_src && <meta property="og:image" content={meta_tags.image_src} />}

        {/* meta_tags.canonical && <link rel="canonical" href={meta_tags.canonical} /> */}
      </Helmet>
    );
  }
}

export default MetaTags;
